<div *ngIf="show" class="alert alert-animated {{ selectAlert.class }} mt-1" role="alert">
  <i class="{{ selectAlert.icon }} mr10"></i>
  <ng-container *ngIf="!selectAlert.param"><span [innerHtml]="selectAlert.text | translate"></span></ng-container>
  <ng-container *ngIf="selectAlert.param"><span [innerHtml]="selectAlert.text | translate:selectAlert.param"></span></ng-container>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/alert/alert.component.html